export const API_HOST = 'https://api.cielomeditation.ru';